import { trackHeapEvent } from './Heap3E';

// Modular event tracking helper with predefined events
export const trackEvent = {
  // User management events
  userCreated: (creatorRole: string, additionalProps?: Record<string, any>) => {
    trackHeapEvent("CUM User Created", {
      creatorRole,
      ...additionalProps
    });
  },

  userUpdated: (updaterRole: string, userId: string, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM User Updated", {
      updaterRole,
      userId,
      ...additionalProps
    });
  },

  userDeleted: (deleterRole: string, userId: string, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM User Deleted", {
      deleterRole,
      userId,
      ...additionalProps
    });
  },

  // Filter and search events
  filterUsed: (filterType: string, filterValue: string, resultCount?: number, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Filter Used", {
      filterType,
      filterValue,
      resultCount,
      ...additionalProps
    });
  },

  searchPerformed: (searchTerm: string, resultCount?: number, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Search Performed", {
      searchTerm,
      resultCount,
      ...additionalProps
    });
  },

  // Export events
  exportClicked: (exportType: string, recordCount?: number, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Export Clicked", {
      exportType,
      recordCount,
      ...additionalProps
    });
  },

  exportCompleted: (exportType: string, recordCount: number, success: boolean, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Export Completed", {
      exportType,
      recordCount,
      success,
      ...additionalProps
    });
  },

  // Location management events
  locationUserManaged: (action: 'assign' | 'edit' | 'remove', userId: string, locationId: string, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Location User Managed", {
      action,
      userId,
      locationId,
      ...additionalProps
    });
  },

  locationSelected: (locationId: string, locationName: string, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Location Selected", {
      locationId,
      locationName,
      ...additionalProps
    });
  },

  // Navigation and UI events
  pageViewed: (pageName: string, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Page Viewed", {
      pageName,
      ...additionalProps
    });
  },

  tabSwitched: (fromTab: string, toTab: string, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Tab Switched", {
      fromTab,
      toTab,
      ...additionalProps
    });
  },

  // Authentication events
  loginAttempted: (method: string, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Login Attempted", {
      method,
      ...additionalProps
    });
  },

  loginSuccessful: (userRole: string, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Login Successful", {
      userRole,
      ...additionalProps
    });
  },

  logoutPerformed: (sessionDuration?: number, additionalProps?: Record<string, any>) => {
      trackHeapEvent("CUM Logout Performed", {
      sessionDuration,
      ...additionalProps
    });
  },

  // Sort events
  sortApplied: (field: string, direction: 'asc' | 'desc' | null | undefined, additionalProps?: Record<string, any>) => {
    trackHeapEvent("CUM Sort Applied", {
      field,
      direction: direction || 'asc', // Default to 'asc' if undefined
      ...additionalProps
    });
  },

  sortCleared: (additionalProps?: Record<string, any>) => {
    trackHeapEvent("CUM Sort Cleared", {
      ...additionalProps
    });
  },

  // Generic event tracker for custom events
  custom: (eventName: string, properties?: Record<string, any>) => {
    trackHeapEvent(eventName, properties);
  }
};

// Direct export of the trackHeapEvent function for advanced usage
export { trackHeapEvent } from './Heap3E';